//
export default [
    {
        text: "código(s) upc",
        value: "upc_codes",
        width: "10%",
        component: {
            type: "chip-list",
        },
    },
    {
        text: "código interno",
        value: "internal_code",
        width: "10%",
    },
    {
        text: "alias",
        value: "alias_name",
        width: "10%",
    },
    {
        text: "nombre",
        value: "name",
        component: {
            custom: 'wh_product_id',
            type: 'link',
            props: {
                mapper: value => ({
                    name: 'product-update',
                        params: {
                            id: value,
                        },
                    }),
                tooltip: 'Detalle del producto',
            },
        },
    },
    {
        text: "stock esperado",
        value: "expected_amount",
        align: "right",
        format: "number",
        width: "15%",
    },
    {
        text: "stock inventariado",
        value: "amount_found_edited",
        align: "right",
        format: "number",
        width: "10%",
    },
    {
        text: "stock a modificar",
        value: "amount_found_new",
        align: "right",
        format: "number",
        input: {
            //nativeType: "number",
            reverse: true,
            type: "float-field",
        },
        width: "10%",
    },
]